import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import "./preloader.css";

const Preloader = ({ onDone }) => {
  const reduce = useReducedMotion();
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (reduce) {
      setDone(true);
      onDone?.();
      return undefined;
    }

    let frame = 0;
    let value = 0;
    const tick = () => {
      value = Math.min(100, value + (value < 70 ? 1.8 : value < 90 ? 0.9 : 0.45));
      setProgress(Math.floor(value));
      if (value < 100) {
        frame = requestAnimationFrame(tick);
      } else {
        setTimeout(() => {
          setDone(true);
          onDone?.();
        }, 280);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [onDone, reduce]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.55, ease: [0.16, 1, 0.3, 1] } }}
        >
          <motion.div
            className="preloader__inner"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <h1 className="preloader__name">
              <span>Mustafa</span> <em>Zeb</em>
            </h1>
            <div className="preloader__track" aria-hidden="true">
              <div
                className="preloader__bar"
                style={{ transform: `scaleX(${progress / 100})` }}
              />
            </div>
            <div className="preloader__meta">
              <span>FULL-STACK & MOBILE</span>
              <span className="preloader__pct">{progress}%</span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
